import type { Invoice } from './useStripeInvoices';

interface Props {
  invoices: Invoice[];
}

export default function InvoiceMetricCards({ invoices }: Props) {
  const totalCount = invoices.length;
  const outstanding = invoices
    .filter((inv) => inv.status === 'sent' || inv.status === 'overdue')
    .reduce((sum, inv) => sum + Number(inv.amount), 0);
  const paid = invoices
    .filter((inv) => inv.status === 'paid')
    .reduce((sum, inv) => sum + Number(inv.amount), 0);
  const overdueCount = invoices.filter(
    (inv) => inv.status === 'sent' && inv.due_date && new Date(inv.due_date) < new Date(),
  ).length;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
      <div
        className="rounded p-4"
        style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
      >
        <div
          className="font-mono text-[10px] uppercase tracking-widest mb-1"
          style={{ color: 'var(--dash-text-dim)' }}
        >
          Total Invoices
        </div>
        <div className="font-mono text-xl" style={{ color: 'var(--dash-text-primary)' }}>
          {totalCount}
        </div>
      </div>
      <div
        className="rounded p-4"
        style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
      >
        <div
          className="font-mono text-[10px] uppercase tracking-widest mb-1"
          style={{ color: 'var(--dash-text-dim)' }}
        >
          Outstanding
        </div>
        <div className="font-mono text-xl" style={{ color: 'var(--dash-text-primary)' }}>
          ${outstanding.toFixed(2)}
        </div>
      </div>
      <div
        className="rounded p-4"
        style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
      >
        <div
          className="font-mono text-[10px] uppercase tracking-widest mb-1"
          style={{ color: 'var(--dash-text-dim)' }}
        >
          Collected
        </div>
        <div className="font-mono text-xl text-emerald-400">${paid.toFixed(2)}</div>
      </div>
      {overdueCount > 0 ? (
        <div className="border border-red-500/20 rounded bg-red-500/5 p-4">
          <div className="font-mono text-[10px] text-red-400 uppercase tracking-widest mb-1">Overdue</div>
          <div className="font-mono text-xl text-red-400">{overdueCount}</div>
        </div>
      ) : (
        <div
          className="rounded p-4"
          style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
        >
          <div
            className="font-mono text-[10px] uppercase tracking-widest mb-1"
            style={{ color: 'var(--dash-text-dim)' }}
          >
            Overdue
          </div>
          <div className="font-mono text-xl" style={{ color: 'var(--dash-text-primary)' }}>
            0
          </div>
        </div>
      )}
    </div>
  );
}
